import React, { useState } from 'react';
import { StyledSubRollingOffer } from './style';
import { SubRollingOfferProps } from 'templates/RollingOffer/shared/types';
import { EBadgePosition, ESubRollingOfferCollectMode } from 'utils/enums';
import { SubRollingOfferPrice } from './components/Price';
import { SubRollingOfferProducts } from './components/Products';
import { HugeSaleBadge } from 'components/Badge/Sale/HugeSaleBadge';
import Badge from 'components/Badge/CornerBadge';

interface ISubRollingOfferProps extends SubRollingOfferProps {
  isAnimating: boolean;
  isPreview: boolean;
}

export const HugeSubRollingOffer: React.FC<ISubRollingOfferProps> = ({
  isAnimating,
  index,
  backgroundColor,
  backgroundImage,
  lockImage,
  buttonColor,
  collectText = 'FREE',
  buttonTextColor,
  collectMode,
  selectOffer,
  prices,
  products,
  isPreview,
  productSale,
  badges,
}) => {
  const [isAnimatingPrice, setIsAnimatingPrice] = useState<boolean>(false);

  const isSelectable =
    collectMode === ESubRollingOfferCollectMode.AVAILABLE &&
    !isAnimating &&
    !isAnimatingPrice;

  return (
    <StyledSubRollingOffer
      className={'sub-offer'}
      backgroundColor={backgroundColor}
      backgroundImage={backgroundImage}
      buttonColor={buttonColor}
      buttonTextColor={buttonTextColor}
      lockImage={lockImage}
      clickable={isSelectable}
      onClick={isSelectable && !isPreview ? selectOffer : undefined}
    >
      {productSale && productSale?.sale > 0 && (
        <HugeSaleBadge
          salePercentage={productSale.sale}
          salePercentageDisplayType={productSale.type}
          customClassName="small"
        />
      )}
      {badges?.[0] && (
        <Badge
          {...badges[0]}
          position={EBadgePosition.LEFT}
          className="small"
        />
      )}
      <SubRollingOfferProducts
        products={products}
        index={index}
        salePercentage={productSale?.sale || 0}
      />
      <SubRollingOfferPrice
        index={index}
        prices={prices}
        buttonText={collectText}
        buttonColor={buttonColor}
        isPreview={false}
        setIsAnimatingPrice={setIsAnimatingPrice}
        lockImage={
          collectMode === ESubRollingOfferCollectMode.LOCKED ? lockImage : ''
        }
      />
    </StyledSubRollingOffer>
  );
};
